import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-select-all',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './select-all.component.html',
  styleUrl: './select-all.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SelectAllComponent {

  @Input() model: FormControl;
  @Input() values = [];
  @Input() text = 'Select All'; 

  @Output() toggleCheckbox = new EventEmitter<any>();

  isChecked(): boolean {
    return this.model.value && this.values.length
      && this.model.value.length === this.values.length;
  }

  isIndeterminate(): boolean {
    return this.model.value && this.values.length && this.model.value.length
      && this.model.value.length < this.values.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    this.toggleCheckbox.emit(change.checked)
    if (change.checked) {
      this.model.setValue(this.values.map(row=>row.id.toString()));
    } else {
      this.model.setValue([]);
    }
  }

}
